import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ComponentInteractionService } from '@app/shared/services/component-interaction.service';
import content from 'src/app/content/individual_texto_aporte.json';
import { IResumenPoliza } from 'src/app/shared/Entities/entities';
import { Event } from 'src/app/shared/enums/insights/event';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';

@Component({
  selector: 'app-aportes-input-cui',
  templateUrl: './aportes-input-cui.component.html',
  styleUrls: ['./aportes-input-cui.component.sass'],
})
export class AportesInputCUIComponent implements OnInit, OnChanges {
  monto: number;
  medio: number;
  medioDisable = false;
  message: string;
  @Input() resumen: IResumenPoliza;
  isAPVRegB = false;
  isAPVRegA = false;
  comboMedioPago: any;
  @Input() codigoRamo: any;
  @Input() pagoStyle: any;
  @Input() showMessageCuiNoApv = false;
  @Input() showMessageCuiApvRegimen = false;
  @Input() showImpagosPFEspecial = false;
  @Input() showMessageDecember = false;
  @Output() $onClickAporte = new EventEmitter();
  @Output() $onPolizaHidden = new EventEmitter();
  constructor(
    private componentInteractionService: ComponentInteractionService,
    private appInsightsService: AppInsightsService,
  ) {}

  ngOnInit() {
    this.componentInteractionService.deshabilitarComboMedioPagoAporte$.subscribe(
      value => {
        this.medioDisable = value;
      }
    );
    const codigo = content.codigoRamos.find(x => x.codigo === this.codigoRamo);
    if (!codigo) {
      return;
    }
    this.message = codigo.texto;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.resumen) {
      return;
    }

    const resumen = changes.resumen.currentValue as IResumenPoliza;
    if (!resumen || !resumen.RegimenTributario) {
      return;
    }
    this.isAPVRegB = resumen.RegimenTributario.toLowerCase() === 'b';
    this.isAPVRegA = resumen.RegimenTributario.toLowerCase() === 'a';
  }

  onRealizarTraslado() {
    this.appInsightsService.trackEvent(Event.iidpBtnPaySpecificAmount);
    let medioPag;

    switch (this.medio) {
      case 2: {
        medioPag = 'TD';
        break;
      }
      default:
        medioPag = '';
    }

    let datos = {
      monto: this.monto,
      medio: medioPag,
    };

    this.medioDisable = true;
    this.$onClickAporte.emit(datos);
    this.monto = null;
  }

  onChangeElegirMedioPago(event) {
    if (!event) {
      return;
    }
    this.medio = event.value;
  }

  onPolizaHidden() {
    this.$onPolizaHidden.emit(false);
  }

  checkVisibleBack() {
    if (!this.resumen) {
      return false;
    }
    if (this.resumen.PeriodicidadPrima.toLowerCase() === 'u') {
      return false;
    }
    return !this.pagoStyle;
  }
}
